export default __webpack_public_path__ + "static/media/boa-ig.22c432d1.svg";